export namespace TableModels {
  export interface PaginatedResult<T> {
    result: T[];
    resultCount: number;
  }

  export interface PaginatedRequest {
    pageSize: number;
    pageNumber: number;
    sortColumn?: string;
    sortDirection?: SortDirectionEnum;
  }

  export enum SortDirectionEnum {
    Asc = 1,
    Desc = 2,
  }
}
